import { render, staticRenderFns } from "./createSocio3.vue?vue&type=template&id=12fd566e&scoped=true&"
import script from "./createSocio3.vue?vue&type=script&lang=js&"
export * from "./createSocio3.vue?vue&type=script&lang=js&"
import style0 from "./createSocio3.vue?vue&type=style&index=0&id=12fd566e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fd566e",
  null
  
)

export default component.exports